import { Dialog, Label, Stack } from "@fluentui/react"
import { useState } from "react"
import { IAccount } from "../types/IAccount"
import { FolderFilePicker, SelectionType } from "./Shared/FolderFilePicker"

interface GroupDocumentsProps {
	group: IAccount
	closePanel: () => void
}

export function GroupDocuments(props: { group: IAccount }): JSX.Element {
	const { group } = props
	const [_error, setError] = useState<string>(undefined)

	return (
		<Stack tokens={{ childrenGap: 16 }}>
			<Stack tokens={{ childrenGap: 8 }}>
				<Label>Upload Documents</Label>
				<span>Do you have any documents to share?</span>
				<span style={{ fontSize: "12px" }}>
					Accepted formats: <strong>PDF, Excel (.xlsx, .xls), Word (.docx, .doc), PNG, JPEG</strong>
				</span>
			</Stack>
			<FolderFilePicker
				allowFileDownload
				allowSelection={false}
				brokerFilePickerProps={{ entityId: group.accountid }}
				selectionType={SelectionType.onlyFiles}
				allowMultipleSelection={false}
				disabled={false}
				onSelectionMade={() => {
					/*void*/
				}}
				selectedDocuments={[]}
			/>
		</Stack>
	)
}

export function GroupDocumentsDialog({ group, closePanel }: GroupDocumentsProps) {
	return (
		<Dialog
			onDismiss={() => closePanel()}
			styles={{
				main: {
					width: "calc(100vw - 180px) !important",
					minWidth: "calc(100vw - 180px) !important",
					maxWidth: "calc(100vw - 180px) !important",
					height: "calc(100vh - 100px)"
				}
			}}
			hidden={false}
			dialogContentProps={{
				styles: {
					content: {
						height: "100%"
					}
				},
				title: (
					<Stack horizontalAlign="center">
						<h3 style={{ marginTop: 0 }}>Documents: {group.name}</h3>
					</Stack>
				)
			}}
			modalProps={{ isBlocking: true }}>
			<GroupDocuments group={group} />
		</Dialog>
	)
}
